module.exports = __webpack_public_path__ + "img/sddy.53e2e891.png";